document.addEventListener("DOMContentLoaded", replaceHiddenRedirectField());

/**
 * Replaces the default hidden redirect field in the Shopify login form 
 * to ensure that users who were redirected from "/pages/secure-downloads" 
 * are properly sent back to that page after logging in.
 *
 * Functionality:
 * - Checks if the current page is the login page ("/account/login").
 * - Extracts the "return_to" parameter from the URL.
 * - If the "return_to" parameter matches "/pages/secure-downloads":
 *   - Removes the default hidden field that redirects users to "/account".
 *   - Inserts a new hidden field that redirects users back to "/pages/secure-downloads".
 *
 * Safeguards:
 * - Ensures the function only runs on the login page.
 * - Ensures the form exists before attempting modifications.
 * - Prevents errors by checking if the hidden field exists before removing it.
 */
function replaceHiddenRedirectField() {
    const currentPath = window.location.pathname;
    const loginPath = "/account/login";
    
    // return if this is not the login page
    if (currentPath !== loginPath) return;
    
    const expectedPath = "/pages/secure-downloads";
    const urlParams = new URLSearchParams(window.location.search);
    // Extract return_to parameter
    const returnTo = urlParams.get("return_to");

    // Continue only if the return_to path is "/pages/secure-downloads"
    if (returnTo !== expectedPath) return;

    const form = document.querySelector("account-login .form");

    // Undefined safeguard
    if (!form) return;

    // remove the current hidden field from the form
    // that causes the customer to be redirected to
    // the /account page by default
    const hiddenField = form.querySelector('[name="checkout_url"]');
    if (hiddenField) hiddenField.remove();

    // insert new hidden field with the expected path 
    form.insertAdjacentHTML('beforeend', 
    `<input type="hidden" name="checkout_url" value="${expectedPath}">`);
}